import { z } from "zod";

export type NewLinkFormModels = {
  name: string;
  url: string;
  icon: { original: string } | null;
  iconId: string | null;
};

export const NewLinkFormSchema = z.object({
  name: z
    .string()
    .min(1, "Nazwa jest wymagana")
    .max(150, "Nazwa jest za długa. Maksymalnie 150 znaków"),
  url: z.url("Podany ciąg znaków nie jest poprawnym adresem strony"),
  icon: z.object({ original: z.string() }).nullable(),
  iconId: z.string().nullable(),
});
